"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateNBFContractMutation = exports.signVehicleOrderDigitallyMutation = exports.updateMultipleVehicleOrderDraftsMutation = exports.updateOrderDraftMutation = exports.vehicleOrderDraftMutation = exports.vehicleOrderMutation = void 0;
const types_1 = require("../../types");
exports.vehicleOrderMutation = `
  mutation createVehicleOrder($orderId: String!, $customerBosApiId: String){
    createVehicleOrder(orderId: $orderId, customerBosApiId: $customerBosApiId) {
      ...bosOrder
    }
  }
  ${types_1.bosOrderFragment}
`;
exports.vehicleOrderDraftMutation = `
  mutation createVehicleOrderDraft($orderId: String!, $customerBosApiId: String){
    createVehicleOrderDraft(orderId: $orderId, customerBosApiId: $customerBosApiId) {
      ...bosOrder
    }
  }
  ${types_1.bosOrderFragment}
`;
exports.updateOrderDraftMutation = `
  mutation updateVehicleOrderDraft($orderId: String!, $input: BosVehicleOrderDraftInput!){
    updateVehicleOrderDraft(orderId: $orderId, vehicleOrderDraftInput: $input) {
      id
      statusMessage
    }
  }
`;
exports.updateMultipleVehicleOrderDraftsMutation = `
  mutation updateMultipleVehicleOrderDrafts($input: [BosVehicleOrderDraftInput!]!){
    updateMultipleVehicleOrderDrafts(vehicleOrderDraftInput: $input) {
      id
      statusMessage
    }
  }
`;
exports.signVehicleOrderDigitallyMutation = `
  mutation signVehicleOrderDigitally($orderId: String!) {
    signVehicleOrderDigitally(orderId: $orderId) {
      ...bosOrder
    }
  }
  ${types_1.bosOrderFragment}
`;
exports.generateNBFContractMutation = `
  mutation generateNBFContract($orderId: String!) {
    generateNBFContract(orderId: $orderId) {
      content
      contentType
      displayName
      encoding
      name
    }
  }
`;
//# sourceMappingURL=vehicle-order.js.map